module.exports = __webpack_public_path__ + "static/ec2-43f3983213b5fabd5872bde77dac8a44.png";